// extracted by mini-css-extract-plugin
export default {"container":"oneColumnLayout_container__VB0Ae"};